import { ROUTES } from "~/router";
import { VISIT_TYPES, VisitType } from "~/services";

type VisitNavigationResult = {
  route: string;
};

const defaultNavigation: VisitNavigationResult = {
  route: ROUTES.getStartedInsurance,
};

export function getVisitNavigation({
  visitType,
  isLoggedIn,
  isNirvanaEnabled = false,
  bypassesNirvanaCheck = false,
}: {
  visitType: VisitType;
  isLoggedIn: boolean;
  isNirvanaEnabled?: boolean;
  bypassesNirvanaCheck?: boolean;
}): VisitNavigationResult {
  if (isLoggedIn) {
    return visitType === VISIT_TYPES.FOLLOW_UP
      ? { route: ROUTES.hubMeetProviderSelection }
      : defaultNavigation;
  }

  if (
    visitType === VISIT_TYPES.INITIAL &&
    isNirvanaEnabled &&
    !bypassesNirvanaCheck
  ) {
    return { route: ROUTES.schedulingDemographics };
  }

  return defaultNavigation;
}
